<template>
    <div class="main--content container">
            <div class="d-flex mt-4 justify-content-between">
                <div>
                    <div class="main--content-header content-header">
                    <div class="content-header--navbar" >
                        <ul class="content-header--navbar-list">
                            <li class="content-header--navbar-list-item" v-bind:class="page == 'planned' ? 'active' : ''">
                                <a class="btn content-header--navbar-list-item-link" @click="page = 'planned'">Planned</a>
                            </li>
                            <li class="content-header--navbar-list-item" v-bind:class="page == 'completed' ? 'active' : ''">
                                <a class="btn content-header--navbar-list-item-link" @click="page = 'completed'">Completed</a>
                            </li>
                        </ul>
                    </div>
                </div>
                </div>
            </div>
            <div class="mt-3">
              <snag-list-component
                    :status="this.page"
                    :load_url="snag_list_url"
                    :show_url="show_url"
              ></snag-list-component>
            </div>
        </div>
    </template>
    
    <script>
    import SnagListComponent from '../jobs/SnagListComponent.vue'

        export default {
            name: "SnagListPage",
            components: {SnagListComponent},
            props: [
                'job',
                'status',
                'snag_list_url',
                'show_url',
            ],
    
            data(){
                return {
                    errors: [],
                    page:null,
                }
            },
    
            beforeMount() {
                if (this.status){ this.page = this.status; }
            },
        }
    </script>
    